import React, { useEffect, useState } from 'react';
import TaskCommentPage from './TaskCommentPage';
import SingleTaskDetails from './SingleTaskDetails';
import SingleTaskUpdatePage from './SingleTaskUpdatePage';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const TaskDetailsPage = ({ apiType, taskID, drawerState, callApi }) => {
  const userId = Cookies.get('userId');
  const [activeTab, setActiveTab] = useState('details');

  
  // Track page view
  useEffect(() => {
    mixpanel.track('Task Details Page Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (drawerState) {
      setActiveTab('details');
    }
  }, [drawerState]);

  // Add tab change handler
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  return (
    <div className="flex flex-col justify-start items-center w-[28rem] relative">
      <div className=" bg-white px-6 py-3">
        <div className="flex gap-8">
          <button
            className={`text-[1rem] font-semibold transition-colors duration-200 ${
              activeTab === 'details' ? 'text-[#2A565E]' : 'text-gray-400 hover:text-gray-600'
            }`}
            onClick={() => handleTabChange('details')}>
            Task Details
          </button>
          <button
            className={`text-[1rem] font-semibold transition-colors duration-200 ${
              activeTab === 'taskUpdate' ? 'text-[#2A565E]' : 'text-gray-400 hover:text-gray-600'
            }`}
            onClick={() => handleTabChange('taskUpdate')}>
            Task Updates
          </button>
          <button
            className={`text-[1rem] font-semibold transition-colors duration-200 ${
              activeTab === 'comments' ? 'text-[#2A565E]' : 'text-gray-400 hover:text-gray-600'
            }`}
            onClick={() => handleTabChange('comments')}>
            Comments
          </button>
        </div>
        <div className="mt-1">
          <div
            className="h-[2px] bg-[#2A565E] transition-all duration-300"
            style={{
              width:
                activeTab === 'details' ? '90px' : activeTab === 'taskUpdate' ? '100px' : '80px',
              transform: `translateX(${activeTab === 'details' ? '0' : activeTab === 'taskUpdate' ? '117px' : '245px'})`
            }}
          />
        </div>
      </div>
      <div className="w-[100%]">
        {activeTab === 'comments' && <TaskCommentPage taskID={taskID} />}
        {activeTab === 'details' && (
          <SingleTaskDetails
            taskID={taskID}
            apiType={apiType}
            isDrawerOpen={drawerState}
            callApi={callApi}
          />
        )}
        {activeTab === 'taskUpdate' && <SingleTaskUpdatePage taskID={taskID} />}
      </div>
    </div>
  );
};

export default TaskDetailsPage;
